// 需要 jquery
if (!customElements.get("scroll-featured-collection")) {
  customElements.define(
    "scroll-featured-collection",
    class ScrollFeaturedCollection extends HTMLElement {
      constructor() {
        super();
        this.sectionId = $(this).attr("data-sectionId");
        this.desktopShowNum = $(this).attr("data-desktopShowNum");
        this.mobileShowNum = $(this).attr("data-mobileShowNum");
        this.rowGap = $(this).attr("data-rowGap");
        this.sfcSwiper = $(this).find(`.swiper-${this.sectionId}`);

        this.initScrollFeaturedCollection();
      }

      initScrollFeaturedCollection() {
        const that = this;

        setTimeout(function () {
          let windowWidth = $(window).width();
          let rowGap = Number(that.rowGap);
          let mobileShowNum = Number(that.mobileShowNum);
          let desktopShowNum = Number(that.desktopShowNum);
          new Swiper(`#swiper_${that.sectionId}`, {
            autoplay: true,
            slidesPerView: 1,
            // autoHeight: true,
            grid: {
              rows: 2,
            },
            spaceBetween: 20,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            breakpoints: {
              749: {
                slidesPerView: 2,
                grid: {
                  rows: 1,
                },
              },
            },
          });

          // var swiper = new Swiper(".mySwiper", {
          //   slidesPerView: 1,
          //   spaceBetween: 10,
          //   pagination: {
          //     el: ".swiper-pagination",
          //     clickable: true,
          //   },
          //   breakpoints: {
          //     640: {
          //       slidesPerView: 2,
          //       spaceBetween: 20,
          //     },
          //     768: {
          //       slidesPerView: 4,
          //       spaceBetween: 40,
          //     },
          //     1024: {
          //       slidesPerView: 5,
          //       spaceBetween: 50,
          //     },
          //   },
          // });

          // var swiper = new Swiper(".mySwiper", {
          //   slidesPerView: 3,
          //   grid: {
          //     rows: 2,
          //   },
          //   spaceBetween: 30,
          //   pagination: {
          //     el: ".swiper-pagination",
          //     clickable: true,
          //   },
          // });

          // that.sfcSwiper.slick({
          //   slidesToShow: 1,
          //   slidesToScroll: 1,
          //   dots: true,
          //   dots: true,
          //   adaptiveHeight: true,
          //   autoplay: true,
          //   arrows: false,
          // });
        }, 0);
      }
    }
  );
}
